import { useDispatch, useSelector } from "react-redux";
import SwipeHint from "./SwipeHint";
import { setActiveProject } from "../../store";

function ProjectsView({ active }) {
  const dispatch = useDispatch();
  const { projectData } = useSelector((store) => store.app);

  const projectButtons = projectData.map((project, index) => (
    <button
      key={index}
      className="relative h-[38px] my-1 px-1 py-0.5 select-none active:shadow-none w-[86px] rounded text-center bg-black cyan-text pxs-button-shadow"
      type="button"
      onClick={() => {
        dispatch(setActiveProject(index));
      }}
    >
      <p className="text-ellipsis text-sm whitespace-nowrap" style={{ overflow: "hidden" }}>
        {project.title}
      </p>
      {index === 0 && (
        <img
          src="/Button Hint.png"
          alt="click"
          className="absolute h-[35px] w-auto right-[-50px] bottom-[-20px]"
        />
      )}
    </button>
  ));
  return (
    <div className="h-full w-screen flex flex-col">
      <div className="w-full h-[85%] pt-2 px-2 flex flex-col">
        <div className="text-white text-xs mb-1">
          I've worked on multiple projects, where I've collaborated with some
          exceptional people:
        </div>
        <div className="flex flex-col w-full grow overflow-y-auto overflow-x-hidden thin-scrollbar">
          {projectButtons}
        </div>
      </div>
      {active && <SwipeHint className="h-[15%]" />}
    </div>
  );
}

export default ProjectsView;
